export var GNGFarben: {[identifier: string]: number} = {
    "weiß": 0xffffff,
    "weiss": 0xffffff,
    "rot": 0xff0000,
    "grün": 0x00ff00,
    "gruen": 0x00ff00,
    "blau": 0x0000ff,
    "gelb": 0xffff00,
    "magenta": 0xff00ff,
    "cyan": 0x00ffff,
    "hellgelb": 0xffff80,
    "hellgrün": 0x80ff80,
    "hellgruen": 0x80ff80,
    "orange": 0xff8000,
    "braun": 0x804000,
    "grau": 0x808080,
    "schwarz": 0x000000
}